.panel {
  width: 360px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px;
  background: var(--white);
  border: var(--b);
  border-radius: var(--r-lg);
  position: sticky;
  top: 24px;
  align-self: flex-start;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}

.empty {
  padding: 40px 16px;
  text-align: center;
  color: var(--mute);
  font-family: var(--sans);
  font-size: 13px;
}

.header {
  display: grid;
  grid-template-columns: 56px 1fr auto;
  gap: 12px;
  align-items: start;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: var(--r-md);
  background: var(--ink);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--sans);
  font-weight: 900;
  font-size: 16px;
}

.headerInfo {
  min-width: 0;
}

.name {
  margin: 0;
  font-family: var(--sans);
  font-weight: 900;
  font-size: 18px;
  letter-spacing: -0.4px;
  line-height: 1.1;
  color: var(--ink);
}

.meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-family: var(--mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: var(--mute);
  flex-wrap: wrap;
}

.id { color: var(--ink-soft); }
.sep { opacity: 0.4; }

.openCta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: var(--r-sm);
  border: 2px solid var(--line);
  background: var(--orange);
  color: var(--ink);
  font-family: var(--sans);
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: var(--sh-1);
  transition: transform 0.08s;
}

.openCta:hover {
  transform: translate(-1px, -1px);
  box-shadow: var(--sh-2);
}

.cardsGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 4px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border: 1.5px solid var(--line-soft);
  border-radius: var(--r-md);
  background: var(--white);
}

.cardAdhGood {
  background: var(--green);
  color: var(--white);
  border-color: var(--green-deep);
}

.cardAdhGood .cardEyebrow,
.cardAdhGood .cardSub { color: rgba(255, 255, 255, 0.85); }
.cardAdhGood .cardValue { color: var(--white); }

.cardEyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--sans);
  font-weight: 900;
  font-size: 9.5px;
  letter-spacing: 1.2px;
  color: var(--mute);
  text-transform: uppercase;
}

.cardValue {
  font-family: var(--sans);
  font-weight: 900;
  font-size: 28px;
  line-height: 1;
  letter-spacing: -1px;
  color: var(--ink);
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.cardUnit {
  font-size: 12px;
  font-weight: 700;
  color: var(--mute);
}

.cardSub {
  font-family: var(--mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.1px;
  color: var(--mute);
  text-transform: uppercase;
}

.cardWide {
  padding: 12px 14px;
  border: 1.5px solid var(--line-soft);
  border-radius: var(--r-md);
  background: var(--white);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cardWideText {
  font-family: var(--sans);
  font-weight: 600;
  font-size: 13px;
  color: var(--ink-soft);
  line-height: 1.4;
}

.cardWideRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

/* Trasparenza multi-piano (0035, Q2 design): badge origine del piano attivo. */
.originBadge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-family: var(--sans);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

.originOwn {
  background: var(--green, #e5f6ea);
  color: var(--green-deep, #0b8a3e);
  border: 1px solid var(--green-deep, #0b8a3e);
}

.originSelfPdf {
  background: #fff4e5;
  color: #a05a00;
  border: 1px solid #e0a030;
}

.originOther {
  background: var(--surface-2, #f0f0f0);
  color: var(--mute);
  border: 1px solid var(--line);
}
